import ReactController from '~/controllers/react_controller'
import AWSEC2MetricsCharts from '~/dashboard/aws_ec2_metrics_charts'

export default class AWSEC2MetricsChartsController extends ReactController {
  static values = {
    organizationId: String,
    resourceId: String,
    hasMemoryData: Boolean,
  }

  createComponent() {
    return (
      <AWSEC2MetricsCharts
        organizationId={this.organizationIdValue}
        resourceId={this.resourceIdValue}
        hasMemoryData={this.hasMemoryDataValue}
      />
    )
  }
}
